import React, { useRef, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import DatePicker from "react-datepicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import "react-datepicker/dist/react-datepicker.css";

// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useEffect } from "react";

import { getMonthlyDetails, getOverallCounterDetail } from "./reportsApi";
// import GstReportCard from "./gstReportCard";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import CounterSalesItemCard from "./counterItemCard";
import axios from "../../../utils/axios";
import {
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getStartOfMonth,
  payloadDateFormat,
} from "../../../utils/commonUtils";
import { Gradient } from "@mui/icons-material";
import { ArrowBackIcon, navigate } from "../../../common/icon";
import { useNavigate } from "react-router";
const TotalCounterSellReport = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [gstReports, setgstReports] = useState({
    totalSales: "",
    gstReports: [],
  });
  const [counterSales, setCounterSales] = useState();
  const [billFilter, setBillFilter] = useState("cash");

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [startDateFormat, setstartDateFormat] = useState(dayjs());

  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getCounterSales = async (param) => {
    await getOverallCounterDetail(param)
      .then((res) => {
        console.log("GetOverall ", res?.data?.data);
        setCounterSales(res?.data?.data);
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(newValue.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };

  useEffect(() => {
    console.log("start date ", startDateFormat);
    console.log("display End ", endDate);
    getCounterSales({
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, [startDateFormat, endDate]);

  useEffect(() => {
    console.log("datE ", payloadDateFormat());
    getCounterSales({
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, []);

  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());

  const downloadXLSXFile = async (param) => {
    try {
      const response = await axios.post(
        "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
        param,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  return (
    <>
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          {/* Back Icon */}
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>
          <Grid
            item
            // xs={12}
            xs
          >
            {" "}
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B",
                textAlign: "left",
                marginBottom: "20px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography variant="h6">Total Counter Sale Report</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            // height: "50px",
            gap: 2,
          }}
        >
          <Grid item xs={10}>
            <TextField
              label="Date"
              size="small"
              value={
                SelectedStartDate && SelectedEndDate
                  ? `${SelectedStartDate.format(
                      "DD-MM-YYYY",
                    )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                  : SelectedStartDate
                    ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                    : ""
              }
              id="datepickerfield"
              placeholder="Select date range"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <CalendarMonthIcon
                    sx={{
                      cursor: "pointer",
                      mr: 1,
                    }}
                    onClick={() => setStartDateOpen(true)} // trigger open
                  />
                ),
                sx: {
                  background: "#fff",
                  borderRadius: 1,
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 500,
                },
              }}
              onClick={() => setStartDateOpen(true)} // trigger open
              sx={{
                width: "100%",
                border: "none",
                "& fieldset": { border: "none" },
              }}
            />

            <Box sx={{ position: "relative" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={startDateOpen}
                  onOpen={() => setStartDateOpen(true)}
                  onClose={() => setStartDateOpen(false)}
                  value={SelectedStartDate}
                  onChange={(val) => {
                    datePickerOnChange(val);
                  }}
                  maxDate={SelectedEndDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-end",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={endDateOpen}
                  onOpen={() => setEndDateOpen(true)}
                  onClose={() => setEndDateOpen(false)}
                  value={SelectedEndDate}
                  onChange={(val) => {
                    datePickerOnChangeEnd(val);
                  }}
                  minDate={SelectedStartDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-start",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

          <Grid
            item
            md={2}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{ height: "40px", backgroundColor: "#14008B" }}
              endIcon={<FileDownloadIcon />}
              onClick={() =>
                downloadXLSXFile({
                  fromDate: startDateFormat,
                  toDate: endDate,
                })
              }
            >
              Download
            </Button>
          </Grid>
        </Grid>
        <Grid xs={12}>
          <Grid
            container
            my={1}
            sx={{
              padding: "10px",
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={"auto"}
              sx={{
                padding: "8px 16px",
                margin: "8px 8px 0px 0",
                fontWeight: "500",
                backgroundColor: "#CCCCFF",
                borderRadius: "8px",
              }}
            >
              <Typography
                component="p"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                  color: "#00008B",
                }}
              >
                <Typography component="span" sx={{ fontWeight: 500 }}>
                  Total Sale:&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{ fontWeight: "bold", marginLeft: "8px" }}
                >
                  {counterSales?.totalSale?.toFixed(2)}
                </Typography>
              </Typography>
            </Grid>

            <Grid
              item
              xs={"auto"}
              sx={{
                padding: "8px 16px",
                margin: "8px 8px 0px 0",
                fontWeight: "500",
                backgroundColor: "#CCCCFF",
                borderRadius: "8px",
              }}
            >
              <Typography
                component="p"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                  color: "#00008B",
                }}
              >
                <Typography component="span" sx={{ fontWeight: 500 }}>
                  Online Sale:&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{ fontWeight: "bold", marginLeft: "8px" }}
                >
                  {counterSales?.digitalSale?.toFixed(2)}
                </Typography>
              </Typography>
            </Grid>

            <Grid
              item
              xs={"auto"}
              sx={{
                padding: "8px 16px",
                margin: "8px 8px 0px 0",
                fontWeight: "500",
                backgroundColor: "#CCCCFF",
                borderRadius: "8px",
              }}
            >
              <Typography
                component="p"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                  color: "#00008B",
                }}
              >
                <Typography component="span" sx={{ fontWeight: 500 }}>
                  Cash Sale:&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{ fontWeight: "bold", marginLeft: "8px" }}
                >
                  {counterSales?.cashSale?.toFixed(2)}
                </Typography>
              </Typography>
            </Grid>
            <Grid
              item
              xs={"auto"}
              sx={{
                padding: "8px 16px",
                margin: "8px 8px 0px 0",
                fontWeight: "500",
                backgroundColor: "#CCCCFF",
                borderRadius: "8px",
              }}
            >
              <Typography
                component="p"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                  color: "#00008B",
                }}
              >
                <Typography component="span" sx={{ fontWeight: 500 }}>
                  Credit Sale:&nbsp;&nbsp;&nbsp;
                  {/* (
                    <Typography component="span">
                      <CurrencyRupeeIcon color="dark" fontSize="10px" />
                    </Typography>) : */}
                </Typography>
                <Typography
                  component="span"
                  sx={{ fontWeight: "bold", marginLeft: "8px" }}
                >
                  {counterSales?.creditSale?.toFixed(2)}
                </Typography>
              </Typography>
            </Grid>
          </Grid>
          <Box
            sx={{
              backgroundColor: "white",
              width: "100%",
              padding: "10px",
              borderRadius: "12px",
            }}
          >
            <Grid container sx={{ p: "10px", mt: 2, background: "white" }}>
              <Grid item xs={12}>
                <Grid container sx={{ borderBottom: "1.5px solid black" }}>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        overflow: "Hidden",
                        display: "-webkit-box",
                        "-webkit-line-clamp": "1",
                        "-webkit-box-orient": "vertical",
                        // fontWeight: 700,
                        p: "0px 22px",
                        color: "#01008B",
                        marginLeft: "30px",
                        fontWeight: 500,
                      }}
                    >
                      Date
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    sx={{
                      fontSize: "15px",
                      overflow: "Hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": "1",
                      "-webkit-box-orient": "vertical",
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Amount
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ height: "60vh", overflow: "auto", marginTop: "10px" }}
              >
                {counterSales?.counterSalesDetails?.map((item, i) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      // lg={6}
                      key={"payamentRecpt" + i}
                      sx={{ p: "0px" }}
                    >
                      <CounterSalesItemCard item={item} />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </>
  );
};

export default TotalCounterSellReport;
